import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./Component/Header";
import HeroSection from "./Component/Herisection";
import AboutVillage from "./Component/About";
import LeadersSection from "./Component/LeadersSection";
import AwardsSection from "./Component/AwardsSection";
import Schemes from "./Component/Schemes";
import ContactForm from "./Component/Cntact"; 
import VillageHistory from "./Component/VillageHistory";
import ContactSection from "./Component/ContactSection";
import Footer from "./Component/Footer";
import LocationInfo from "./aapchyavishai/LocationInfo";
import MissionSection from "./aapchyavishai/MissionSection";
import GoalsSection from "./aapchyavishai/GoalSection";
import MembersSection from "./aapchyavishai/Member";
import AdministrationSection from "./aapchyavishai/Addminister";
import SchoolsSection from "./aapchyavishai/Schoolsection";
import GavVikasSection from "./Component/Yashogatha";
import Gallary from "./Component/Gallary";
import GramSabhaSection from "./Component/Gramsabha";
import Utare from "./Component/utare";
import Palour from "./Component/Palour";
import Ruksharopan from "./Component/Ruksharopan";
import SchoolRuksha from "./Component/School";
import Ganpati from "./Component/Ganpati";
import Lokvargani from "./Component/Lokvargani";
import Gharkul from "./Component/Gharkul";
import PanchayatSection from "./Component/Abhiyan";
import PanchayatMissionSection from "./Component/AbhiyanTwo";
import Mukhyamantri from "./Component/Mukhyamantri";
import Gav from "./Component/Gav";
import DigitalKarVasuli from "./Component/DigitalKarVasuli";

// --------------------
// Scroll To Top Inside App.jsx
// --------------------
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
// --------------------

const App = () => {
  return (
    <Router>
      <ScrollToTop />  {/* This scrolls page to top on route change */}
      <Header />

      <Routes>
        <Route
          path="/"
          element={
            <>
              <HeroSection />
              <AboutVillage />
              <DigitalKarVasuli/>
              <VillageHistory />
              <LeadersSection />
              <AwardsSection />
              <Schemes />

              <ContactForm />
              <Footer/>
            </>
          }
        />

        <Route
  path="/locationinfo"
  element={
    <>
     <MissionSection/>
      <LocationInfo /> 
      <GoalsSection/>
      <AdministrationSection/>
      <MembersSection/>
      <SchoolsSection/>
       <ContactForm />
      <Footer />
    </>
   
  }
/>

<Route 
  path="/yashogatha" 
  element={
    <>
      <GavVikasSection />
      <AwardsSection />
      <ContactForm />
      <Footer />
    </>
  } 
/>

<Route path="/gallary" element={
  <>
   <Gallary/>
   <Mukhyamantri/>
   <Gav/>
   <SchoolRuksha/>
  <Palour/>

   <Ruksharopan/>
  <GramSabhaSection/>
  <Ganpati/>
  <Gharkul/>
  <Lokvargani/>
  <Utare/>
  <ContactForm/>
  <Footer/>
  </>
}
/>
<Route  path="/abhiyan" element={
  <>
  <PanchayatSection/>
  <PanchayatMissionSection/>
   <ContactForm/>
  <Footer/>
  
  </>
}
/>

    


        <Route
          path="/contact"
          element={
            <>
              <ContactSection />
              <ContactForm />
               <Footer/>
            </>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
